function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.9 52.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.34,10.85h-1.93c-1.1-6.17-6.52-10.85-12.98-10.85s-11.89,4.69-13,10.85h-1.88C4.28,10.85,0,15.14,0,20.42v16.42c0,8.71,7.05,15.77,15.76,15.77h17.38c8.7,0,15.76-7.06,15.76-15.76v-16.44c0-5.28-4.29-9.57-9.56-9.57ZM24.43,3.67c4.46,0,8.19,3.06,9.24,7.18H15.18c1.04-4.12,4.8-7.18,9.25-7.18ZM36.44,22.26c-2.08,4.52-6.67,7.67-11.99,7.67s-9.9-3.15-11.98-7.67c-.11-.24-.17-.5-.17-.74,0-.97.8-1.84,1.85-1.84.7,0,1.34.4,1.65,1.04,1.5,3.27,4.82,5.55,8.65,5.55s7.15-2.29,8.66-5.55c.3-.64.94-1.04,1.65-1.04,1.32,0,2.24,1.38,1.68,2.58Z",
    style: {
      fill: "#ffffff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset42);
export default __webpack_public_path__ + "static/media/Asset 42.5e1374be0632ca5962aa79865d0d4675.svg";
export { ForwardRef as ReactComponent };